import MicroModal from 'micromodal';
import '../components/product-modal';
import tippy from 'tippy.js';
import '../components/cart-add';
import clickAndCollect from '../services/click-and-collect';
import { openModal } from '../helpers/modal';
import i18n from 'roddeh-i18n';
import Cart from '../services/cart';
let sliderMain;
let sliderColors;
let selectedProduct;
const addProductDetailsTabListener = () => {
    document.querySelectorAll('.product-card__details-tab-element').forEach((elem) => {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelectorAll('.product-card__details-tab-content').forEach((content) => {
                content.style.display = 'none';
            });
            const targetId = elem.getAttribute('for');
            const target = document.querySelector('#' + targetId);
            if (target) {
                document.querySelectorAll('.product-card__details-tab-element').forEach((tabLinks) => {
                    tabLinks.classList.remove('selected');
                });
                elem.classList.add('selected');
                target.style.display = 'block';
            }
        });
    });
};
const addSortReviewsListener = () => {
    const sortReview = document.querySelector('.product-reviews__filters-sort-selected');
    if (sortReview) {
        sortReview.addEventListener('click', (e) => {
            e.preventDefault();
            const sortReviewBox = document.querySelector('.product-reviews__filters-sort-options');
            if (sortReviewBox) {
                if (sortReviewBox.style.display === 'block') {
                    sortReviewBox.style.display = 'none';
                }
                else {
                    sortReviewBox.style.display = 'block';
                }
            }
            e.stopPropagation();
        });
        document.addEventListener('click', function () {
            const sortReviewBox = document.querySelector('.product-reviews__filters-sort-options');
            if (sortReviewBox) {
                sortReviewBox.style.display = 'none';
            }
        });
    }
};
const addRateCommentListener = () => {
    document.querySelectorAll('.product-reviews__item-vote-button').forEach((elem) => {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            const commentId = elem.dataset.id;
            const isHelpful = elem.dataset.helpful;
            if (commentId && isHelpful) {
                const formData = new FormData();
                formData.append('comment_id', commentId);
                formData.append('is_helpful', isHelpful);
                const reviewsButtonContainer = elem.parentElement;
                fetch('/reviews/rate', {
                    method: 'POST',
                    cache: 'no-cache',
                    body: formData,
                })
                    .then((response) => {
                    if (response.ok === false) {
                        throw new Error('Unknown failure');
                    }
                    return response.json();
                })
                    .then((response) => {
                    if (reviewsButtonContainer) {
                        if (!response.success && response.error_msg) {
                            reviewsButtonContainer.innerHTML = response.error_msg;
                        }
                        else if (response.success) {
                            reviewsButtonContainer.innerHTML = i18n('Thank you for rating this comment.');
                        }
                    }
                })
                    .catch((err) => {
                    console.error(err);
                });
            }
        });
    });
};
const changeColor = (color, index) => {
    const skuSpan = document.querySelector('.product-card__overview .product_sku');
    document.querySelectorAll('.product-attribute-item').forEach((elem2) => {
        elem2.classList.remove('active');
    });
    document.querySelectorAll('.product-attribute-item').forEach((attrItem) => {
        const attrItemImage = attrItem.querySelector('img');
        if (attrItemImage && attrItemImage.dataset.sku && attrItemImage.dataset.sku == color.sku) {
            attrItem.classList.add('active');
        }
    });
    if (skuSpan) {
        //podmiana wartosci
        skuSpan.innerText = color.sku;
        //ustawienie sku w URL
        if ('URLSearchParams' in window) {
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams(url.search);
            searchParams.set('s', color.sku);
            const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.replaceState(null, '', newRelativePathQuery);
        }
    }
    sliderColors.goTo(index);
    if (sliderMain) {
        sliderMain.destroy();
    }
    const imageSlider = document.querySelector('.product-card__images-slider');
    const addToCartButton = document.querySelector('.product-card__overview-button.product-overview__available');
    const addToCartUnavailable = document.querySelector('.product-card__overview-button-unavailable');
    const navImages = document.querySelector('.product-card__images-list');
    const colorName = document.querySelector('.product-card__overview-colors-wrapper .color-info .color-name');
    const quantityInput = document.querySelector('.product-card__overview-quantity-wrapper #quantity');
    if (quantityInput) {
        quantityInput.setAttribute('max', color.availability.max_cart_quantity.toString());
        if (addToCartButton && addToCartUnavailable) {
            if (color.availability.max_cart_quantity < 1) {
                addToCartButton.style.display = 'none';
                addToCartUnavailable.style.display = 'flex';
                document
                    .querySelectorAll('.product-card__overview-sticky-box .webpush')
                    .forEach((elem) => {
                    elem.style.display = 'flex';
                    const btn = elem.querySelector('webpush-button');
                    if (btn !== null) {
                        btn.setAttribute('subscriptiondetails', JSON.stringify({
                            SKU: color.sku,
                        }));
                    }
                });
                document.querySelectorAll('.product-card__overview-points_info').forEach((elem) => {
                    elem.style.display = 'none';
                });
            }
            else {
                addToCartButton.style.display = 'block';
                addToCartUnavailable.style.display = 'none';
                document
                    .querySelectorAll('.product-card__overview-sticky-box .webpush')
                    .forEach((elem) => {
                    elem.style.display = 'none';
                });
                document.querySelectorAll('.product-card__overview-points_info').forEach((elem) => {
                    elem.style.display = 'flex';
                });
            }
        }
    }
    if (addToCartButton) {
        addToCartButton.setAttribute('sku', color.sku);
    }
    if (colorName) {
        colorName.innerText = color.attribute_name;
    }
    if (imageSlider && navImages) {
        imageSlider.innerHTML = '';
        navImages.innerHTML = '';
        const productCustomStickerInput = document.querySelector('.product-card__images #customProductSticker');
        let customProductSticker = '';
        if (productCustomStickerInput) {
            customProductSticker =
                '<img class="product-card__images-sticker" src="' + productCustomStickerInput.value + '" />';
        }
        for (const mainColor of color.images) {
            if (mainColor.type === 'main' || mainColor.type === 'additional') {
                for (const size of mainColor.sizes) {
                    if (size.size === '101x101') {
                        const navImagesItem = document.createElement('div');
                        navImagesItem.innerHTML = '<img src="' + size.url + '"/>';
                        navImages.appendChild(navImagesItem);
                    }
                    if (size.size === '500x500') {
                        const mainSliderItem = document.createElement('div');
                        mainSliderItem.innerHTML = customProductSticker + '<img src="' + size.url + '"/>';
                        imageSlider.appendChild(mainSliderItem);
                    }
                }
            }
        }
    }
    sliderMain = sliderMain.rebuild();
    document.querySelectorAll('.product-card__images-main wishlist-button').forEach((btn) => {
        btn.setAttribute('sku', color.sku);
    });
};
const addAttributesColorListener = () => {
    document.querySelectorAll('.product-attribute-item').forEach((elem) => {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            const image = elem.querySelector('img');
            if (image) {
                const sku = image.dataset.sku;
                const id = image.dataset.id ? parseInt(image.dataset.id) : null;
                const canBeBought = image.dataset.canBeBought;
                const title = image.getAttribute('title');
                const available = image.dataset.available ? parseInt(image.dataset.available) > 0 : false;
                const isActive = image.dataset.isActive ? image.dataset.isActive === '1' : false;
                const index = image.dataset.index ? parseInt(image.dataset.index) : 0;
                let dataImages = [];
                const images = [];
                if (image.dataset.images) {
                    dataImages = JSON.parse(image.dataset.images);
                    for (const image of dataImages) {
                        images.push({
                            sizes: [
                                {
                                    size: '500x500',
                                    url: '/uimg/product_catalog_500x500/' + image,
                                },
                                {
                                    size: '101x101',
                                    url: '/uimg/product_catalog_101x101/' + image,
                                },
                            ],
                            type: 'additional',
                        });
                    }
                }
                let quantity = 0;
                if (image.dataset.available) {
                    quantity = parseInt(image.dataset.available);
                }
                if (id && sku && title && null !== canBeBought) {
                    const color = {
                        id: id,
                        sku: sku,
                        attribute_name: title,
                        images: images,
                        active: isActive,
                        availability: {
                            can_be_bought: available,
                            max_cart_quantity: quantity,
                        },
                    };
                    changeColor(color, index);
                }
            }
        });
    });
    if (selectedProduct) {
        if (selectedProduct.preselected_SKU &&
            selectedProduct.SKU != selectedProduct.preselected_SKU &&
            selectedProduct.preselected_SKU !== null) {
            const selectedProductElement = document.querySelector('.product-attribute-item img[data-sku="' + selectedProduct.preselected_SKU + '"]');
            if (selectedProductElement) {
                selectedProductElement.click();
            }
        }
    }
};
const seeAllColorsModal = () => {
    const seeAllColors = document.querySelector('.product-card__overview-all-colors');
    if (seeAllColors) {
        seeAllColors.addEventListener('click', (e) => {
            e.preventDefault();
            const productID = seeAllColors.getAttribute('id');
            const sku = seeAllColors.getAttribute('sku');
            const altshopID = seeAllColors.getAttribute('altshopID');
            if (sku !== null && productID !== null && altshopID !== null) {
                openModal(`
                    <div class="header close-only">
                        <button class="close" data-micromodal-close></button>
                    </div>
                    <div class="content">
                        <product-modal sku="${sku}" productID="${productID}" altshopID="${altshopID}"></product-modal>
                    </div>
                `);
            }
            else {
                console.error('Modal could not be opened, missing sku attribute');
            }
            const productModal = document.querySelector('product-modal');
            if (productModal) {
                productModal.addEventListener('changeColor', (e) => {
                    if (e.detail) {
                        changeColor(e.detail.color, e.detail.index);
                    }
                });
            }
        });
    }
};
const updateQuantity = (type) => {
    const quantityInput = document.querySelector('.product-quantity #quantity');
    const addToCartButton = document.querySelector('.product-card__overview cart-add');
    if (quantityInput && addToCartButton) {
        let quantity = 1;
        let quantityMax = 1;
        const quantityValueAttr = quantityInput.getAttribute('value');
        const quantityMaxAttr = quantityInput.getAttribute('max');
        if (quantityMaxAttr) {
            quantityMax = parseInt(quantityMaxAttr);
        }
        if (quantityValueAttr) {
            quantity = parseInt(quantityValueAttr);
        }
        if (type === 'add') {
            quantity++;
        }
        else if (type === 'sub') {
            quantity--;
        }
        if (quantity > quantityMax) {
            quantity = quantityMax;
        }
        if (quantity < 1) {
            quantity = 1;
        }
        addToCartButton.setAttribute('quantity', quantity.toString());
        quantityInput.setAttribute('value', quantity.toString());
    }
};
const productQuantityChangeListener = () => {
    const quantityAdd = document.querySelector('.product-quantity__change-plus');
    const quantitySub = document.querySelector('.product-quantity__change-minus');
    if (quantityAdd && quantitySub) {
        quantityAdd.addEventListener('click', (e) => {
            e.preventDefault();
            updateQuantity('add');
        });
        quantitySub.addEventListener('click', (e) => {
            e.preventDefault();
            updateQuantity('sub');
        });
    }
};
const productAsGiftListener = () => {
    Cart.addListener((event) => {
        const skuSpan = document.querySelector('.product-card__overview .product_sku');
        const productAsGiftButton = document.querySelector('.product-card__overview-button.product-as-gift');
        if (event.name === 'promotionsChanged' && skuSpan && productAsGiftButton) {
            let matchedAction = false;
            Cart.getPromotionForSKU(skuSpan.innerText)
                .then((promotions) => {
                promotions.forEach((promotion) => {
                    promotion.actions.forEach((action) => {
                        if (action.type === 'product_as_gift') {
                            productAsGiftButton.innerText = action.settings.button_text;
                            productAsGiftButton.style.display = 'flex';
                            matchedAction = true;
                        }
                    });
                });
            })
                .catch((err) => {
                console.error('Failed to get promotions for SKU to check if product as gift promotion is active', err);
            });
            if (!matchedAction) {
                productAsGiftButton.style.display = 'none';
            }
        }
    });
};
export default (slider, sliderAttributes, product) => {
    sliderMain = slider;
    sliderColors = sliderAttributes;
    selectedProduct = product;
    const deliveryTip = document.querySelector('.delivery-tip');
    if (deliveryTip && deliveryTip.dataset.tipContent) {
        tippy(deliveryTip, {
            content: deliveryTip.dataset.tipContent,
            allowHTML: true,
            theme: 'default',
            animation: 'scale',
            placement: 'left',
            trigger: 'click',
        });
    }
    const chooseShopTip = document.querySelector('.click-and-collect-tip');
    if (chooseShopTip && chooseShopTip.dataset.tipContent) {
        tippy(chooseShopTip, {
            content: chooseShopTip.dataset.tipContent,
            allowHTML: true,
            theme: 'default',
            animation: 'scale',
            placement: 'left',
            trigger: 'click',
        });
    }
    const deliveryOptionsTip = document.querySelector('.delivery-options-tip');
    if (deliveryOptionsTip && deliveryOptionsTip.dataset.tipContent) {
        tippy(deliveryOptionsTip, {
            content: deliveryOptionsTip.dataset.tipContent,
            allowHTML: true,
            theme: 'default',
            animation: 'scale',
            placement: 'left',
            trigger: 'click',
        });
    }
    const deliveryOptionsTrigger = document.querySelector('.show-delivery-options');
    if (deliveryOptionsTrigger) {
        deliveryOptionsTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalDeliveryOptions = document.querySelector('#modal-delivery-options');
            if (modalDeliveryOptions) {
                MicroModal.show('modal-delivery-options', {
                    disableScroll: true,
                    onClose: (modal, activeElement, event) => {
                        // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                        if (event !== null) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    },
                });
            }
        });
    }
    document.querySelectorAll('.cc-choose-shop, .js-cc-choose-shop').forEach((chooseShop) => {
        chooseShop.addEventListener('click', (e) => {
            e.preventDefault();
            const remote = chooseShop.dataset.remote;
            const skus = chooseShop.dataset.skus;
            const shopId = chooseShop.dataset.shopId;
            if (remote && skus) {
                const formData = new FormData();
                formData.append('skus', skus);
                formData.append('limit', '0');
                fetch(remote, {
                    method: 'POST',
                    cache: 'no-cache',
                    body: formData,
                })
                    .then((response) => {
                    if (response.ok === false) {
                        throw new Error('Unknown failure');
                    }
                    return response.text();
                })
                    .then((response) => {
                    const modalCCShops = document.querySelector('#modal-cc-shops');
                    if (modalCCShops) {
                        const modalCCShopsContent = modalCCShops.querySelector('.content');
                        if (modalCCShopsContent) {
                            modalCCShopsContent.innerHTML = response;
                        }
                        modalCCShops.dataset.remote = remote;
                        modalCCShops.dataset.skus = skus;
                        modalCCShops.dataset.shopId = shopId;
                        MicroModal.show('modal-cc-shops', {
                            disableScroll: true,
                            onClose: (modal, activeElement, event) => {
                                // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                                if (event !== null) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            },
                        });
                        clickAndCollect.initModal(modalCCShops);
                    }
                })
                    .catch((err) => {
                    console.error(err);
                });
            }
        });
    });
    const oneyModalTrigger = document.querySelector('.js-oney-popup-trigger');
    if (oneyModalTrigger) {
        oneyModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalOney = document.querySelector('#modal-oney');
            if (modalOney) {
                MicroModal.show('modal-oney', {
                    disableScroll: true,
                    onClose: (modal, activeElement, event) => {
                        window.dispatchEvent(new Event('oney-modal-close'));
                        // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                        if (event !== null) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    },
                });
            }
        });
    }
    const addToCartButton = document.querySelector('.product-card__overview-button');
    const addToCartButtonAnchor = document.querySelector('.add-to-cart-observer-anchor');
    const observer = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        if (addToCartButton) {
            if (entries[0].isIntersecting === true) {
                addToCartButton.classList.add('sticky');
            }
            else if (entries[0].isIntersecting === false && entry.boundingClientRect.top > 0) {
                addToCartButton.classList.remove('sticky');
            }
        }
    }, { threshold: [1] });
    if (addToCartButtonAnchor) {
        observer.observe(addToCartButtonAnchor);
    }
    productAsGiftListener();
    seeAllColorsModal();
    addProductDetailsTabListener();
    addRateCommentListener();
    addAttributesColorListener();
    productQuantityChangeListener();
    addSortReviewsListener();
    clickAndCollect.initSelected();
    clickAndCollect.initProductCardClearButton();
};
